import form_module_default from "./form.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
import { Root } from "@radix-ui/react-form";
//#region src/components/Form/Root.tsx
/**
* Thin wrapper around Radix UI Root component
* https://www.radix-ui.com/docs/primitives/components/form#root
*/
var Root$1 = forwardRef(function Root$2({ children, ...props }, ref) {
	const classes = classNames(form_module_default.root, props.className);
	return /* @__PURE__ */ jsx(Root, {
		ref,
		...props,
		className: classes,
		children
	});
});
//#endregion
export { Root$1 as Root };

//# sourceMappingURL=Root.js.map